<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs required">{{ $t('dealerWithdrawal.tranType') }}</label>
            <a-select v-model.number="model.tran_type_id" class="ts-w-full">
              <a-select-option :value="14">Dealer Withdrawal</a-select-option>
              <a-select-option :value="15">Closed Account</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs required">{{ $t('dealerWithdrawal.dealer') }}</label>
            <a-select
              class="ts-w-full"
              v-model="model.dealer_id"
              showSearch
              :allowClear="true"
              :placeholder="$t('dealerWithdrawal.searchDealerName')"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="fetching ? undefined : null"
              @search="fetchDealer"
              :options="dealer_lists"
              @change="dealerChange"
            >
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="(d, index) in dealer_lists" :key="index" :value="d.value">
                  {{ d.label }}
                </a-select-option>
            </a-select>
            <div class="validate ts-text-xs" v-if="errors.has('dealer_id')">{{ errors.first('dealer_id') }}</div>
            <div
              v-if="model.dealer_id"
              class="ts-mx-2 ts-border-t-0 ts-border ts-border-gray-400 ts-p-2 ts-rounded-bl-md ts-rounded-br-md ts-flex ts-items-center ts-justify-between"
            >
              <strong
                class="ts-text-xs ts-text-gray-500"
              >{{ $t('dealerWithdrawal.availableAmount') }}</strong>
              <strong class="ts-text-blue-600">{{ model.available_amount }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs required">{{ $t('dealerWithdrawal.amount') }}</label>
            <input
              v-model.number="model.withdrawal_amount"
              type="number"
              step="any"
              class="form-control"
            />
            <div
              class="validate ts-text-xs"
              v-if="errors.has('withdrawal_amount')"
            >{{ errors.first('withdrawal_amount') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{ $t('dealerWithdrawal.description') }}</label>
            <textarea v-model.trim="model.description" class="form-control" rows="3"></textarea>
            <div class="validate ts-text-xs" v-if="errors.has('description')">{{ errors.first('description') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-space-x-3 ts-flex ts-justify-end">
          <ts-button
					 @click.prevent="$emit('close')"
					>{{ $t('cancel') }}</ts-button>
          <ts-button 
						color="primary"
						:waiting="waiting"
						@click.prevent="onStore"
					>{{ $t('submit') }}</ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'dealerWithdrawal',
  data() {
    return {
      errors: new Errors(),
			loading: false,
			fetching: false,
			waiting: false,
      dealer_lists: [],
      model: {
        dealer_id: undefined,
        tran_type_id: 14,
        withdrawal_amount: null,
        available_amount: 0,
        description: null
      }
    }
  },
  methods: {
    ...mapActions('accounting/dealerWithdrawal', ['getDealer', 'store']),
    fetchDealer: _.debounce(function(value){
      if(!value) {
        this.dealer_lists = []
      }
      this.fetching = true
      this.getDealer(value)
        .then(response => {
          this.dealer_lists = response.data.map(el => ({
            value: el.dealer_id,
            label: el.dealer_name,
            balance: el.main_balance,
            top_rate: el.topup_commission_rate
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    }, 500),
    dealerChange(value, options) {
      var dealer = options.data.props
      this.model.available_amount = _.round(
        (dealer.balance * 100) / (100 + dealer.top_rate),
        2
      )
		},
		onStore(){
			this.waiting = true
			this.store(this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.clearInput()
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
		},
		clearInput(){
			this.model.dealer_id = null
      this.model.tran_type_id = 14
      this.model.withdrawal_amount = null
      this.model.available_amount = 0
      this.model.description = null
		}
  }
}
</script>